export default interface FilterItem {
    id: string | number | boolean
    value: string | number | boolean
    label: string
}

export enum SkillFilterSortByType {
    ALL = 'all',
    UPCOMING = 'upcoming',
    PAST = 'past'
}
